import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ReferralService {
  amico: string | null = null;

  getReferralCode(): string | null {
    return this.amico;
  }
}
